export default "__VITE_ASSET__wFSBDN6r__"